import PropTypes from 'prop-types';

import { Box, TableRow, TableCell, TableHead, TableSortLabel } from '@mui/material';

const visuallyHidden = {
  border: 0,
  margin: -1,
  padding: 0,
  width: '1px',
  height: '1px',
  overflow: 'hidden',
  position: 'absolute',
  whiteSpace: 'nowrap',
  clip: 'rect(0 0 0 0)',
};

UserListHead.propTypes = {
  order: PropTypes.oneOf(['asc', 'desc']),
  orderBy: PropTypes.string,
  rowCount: PropTypes.number,
  headLabel: PropTypes.array,
  numSelected: PropTypes.number,
  onRequestSort: PropTypes.func,
  onSelectAllClick: PropTypes.func,
  hideSortIcon: PropTypes.bool,
  assign: PropTypes.string,
};

export default function UserListHead({
  order,
  orderBy,
  rowCount,
  headLabel,
  numSelected,
  onRequestSort,
  onSelectAllClick,
  hideSortIcon = true,
  assign = 'id',
}) {
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  return (
    <TableHead>
      <TableRow>
        <TableCell key={'1'} sortDirection={false} style={{ backgroundColor: '#E2F5FC', color: '#0E7496' }}>
          No
        </TableCell>
        {headLabel.map((headCell) => (
          <TableCell
            key={headCell[assign]}
            align={headCell.alignRight ? 'right' : 'left'}
            sortDirection={orderBy === headCell[assign] ? order : false}
            style={{ backgroundColor: '#E2F5FC', color: '#0E7496' }}
          >
            <TableSortLabel
              hideSortIcon={hideSortIcon}
              active={orderBy === headCell[assign]}
              direction={orderBy === headCell[assign] ? order : 'asc'}
              onClick={createSortHandler(headCell[assign])}
            >
              {headCell.label}
              {orderBy === headCell.id ? (
                <Box sx={{ ...visuallyHidden }}>{order === 'desc' ? 'sorted descending' : 'sorted ascending'}</Box>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}
